import type { Provider } from '@angular/core';
import type { IMetadataKeyRepository, ICryptoAdapter, IBiometricAuthPort } from '@app/domain/ports';
import { DekService } from '@app/domain/services';
import {
  UnlockDekWithPasswordUseCase,
  UnlockDekWithPinUseCase,
  UnlockDekWithWebAuthnUseCase,
  UnlockDekWithRawDekUseCase,
} from '@app/domain/use-cases';
import { METADATA_KEY_REPOSITORY, CRYPTO_ADAPTER, BIOMETRIC_AUTH } from '../../tokens/infrastructure.tokens';

export function provideDekDomain(): Provider[] {
  return [
    {
      provide: DekService,
      useFactory: () => new DekService(),
    },
    {
      provide: UnlockDekWithPasswordUseCase,
      useFactory: (repo: IMetadataKeyRepository, crypto: ICryptoAdapter) =>
        new UnlockDekWithPasswordUseCase(repo, crypto),
      deps: [METADATA_KEY_REPOSITORY, CRYPTO_ADAPTER],
    },
    {
      provide: UnlockDekWithPinUseCase,
      useFactory: (repo: IMetadataKeyRepository, crypto: ICryptoAdapter) => new UnlockDekWithPinUseCase(repo, crypto),
      deps: [METADATA_KEY_REPOSITORY, CRYPTO_ADAPTER],
    },
    {
      provide: UnlockDekWithWebAuthnUseCase,
      useFactory: (repo: IMetadataKeyRepository, biometric: IBiometricAuthPort, crypto: ICryptoAdapter) =>
        new UnlockDekWithWebAuthnUseCase(repo, biometric, crypto),
      deps: [METADATA_KEY_REPOSITORY, BIOMETRIC_AUTH, CRYPTO_ADAPTER],
    },
    {
      provide: UnlockDekWithRawDekUseCase,
      useFactory: (crypto: ICryptoAdapter) => new UnlockDekWithRawDekUseCase(crypto),
      deps: [CRYPTO_ADAPTER],
    },
  ];
}
